
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-trials',
  templateUrl: './no-trial.component.html',

  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    TranslateModule
]
})
export class NoTrialsComponent {

  readonly onAction = output<{ action: string }>();

  addTrail(){
    this.onAction.emit({action:"createTrail"});
  }
}
